import {Component, OnInit} from '@angular/core';
import {Store} from "@ngrx/store";
import {Observable} from "rxjs";
import {selectLoggedIn} from "../../store/auth/auth.selectors";

@Component({
    selector: 'app-start',
    templateUrl: './start.component.html',
    styleUrl: './start.component.scss',
})
export class StartComponent implements OnInit {
  isLoggedIn$: Observable<boolean>;

  constructor(private store: Store) {} // Store wird hier richtig initialisiert

  ngOnInit(): void {
    this.isLoggedIn$ = this.store.select(selectLoggedIn); // Login-Status aus NgRx abrufen
  }
}

